import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const NotConnected = ({ showModal }) => {
  const { t } = useTranslation(['organisation'])
  return (
    <div className="not-connected">
      <div className="not-connected__info-block">
        <div className="not-connected__title-wrap">
          <h2 className="not-connected__main-title">
            {t('organisation:reputationManagement.notConnected.title')}
          </h2>
          <p className="not-connected__subtitle">
            {t('organisation:reputationManagement.notConnected.subtitle')}
          </p>
        </div>
        <div className="not-connected__articles-wrap">
          <div className="not-connected__article">
            <h4 className="not-connected__article-title">
              {t('organisation:reputationManagement.notConnected.step1Title')}
            </h4>
            <p className="not-connected__article-text">
              {t('organisation:reputationManagement.notConnected.step1Text')}
            </p>
          </div>
          <div className="not-connected__article">
            <h4 className="not-connected__article-title">
              {t('organisation:reputationManagement.notConnected.step2Title')}
            </h4>
            <p className="not-connected__article-text">
              {t('organisation:reputationManagement.notConnected.step2Text')}
            </p>
          </div>
          <div className="not-connected__article">
            <h4 className="not-connected__article-title">
              {t('organisation:reputationManagement.notConnected.step3Title')}
            </h4>
            <p className="not-connected__article-text">
              {t('organisation:reputationManagement.notConnected.step3Text')}
            </p>
          </div>
        </div>
        <button onClick={showModal} className="not-connected__btn">
          {t('organisation:reputationManagement.notConnected.connect')}
        </button>
      </div>
      <div className="not-connected__img">
        <img
          src="/images/upselling/reputation-management.png"
          alt={t('organisation:reputationManagement.notConnected.imageAlt')}
        />
      </div>
    </div>
  )
}

NotConnected.propTypes = {
  showModal: PropTypes.func,
}

export default NotConnected
